var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowThickDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 14,
    viewBox: "0 0 11 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.20766 13.6799L0.960991 8.99242C0.820281 8.8371 0.735107 8.60207 0.735107 8.4047C0.735107 8.20733 0.820281 7.97229 0.960991 7.81698C1.26217 7.48453 1.72471 7.48453 2.02589 7.81698L4.98177 11.0797V1.70827C4.98177 1.21802 5.29596 0.871216 5.74011 0.871216C6.18425 0.871216 6.49844 1.21802 6.49844 1.70827V11.0797L9.45432 7.81698C9.7555 7.48453 10.218 7.48453 10.5192 7.81698C10.8204 8.14942 10.8204 8.65998 10.5192 8.99242L6.27256 13.6799C6.22853 13.7285 6.19406 13.7523 6.13381 13.7856C6.11443 13.7962 6.11351 13.7969 6.11331 13.7971L6.02438 13.8578C5.83222 13.9285 5.63347 13.9351 5.47429 13.8676C5.37668 13.8552 5.3196 13.8035 5.20766 13.6799Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowThickDown);
export default __webpack_public_path__ + "static/media/arrow-thick-down.4129694d66fe06a558106527ab9dd17b.svg";
export { ForwardRef as ReactComponent };